/**
 * category-colors.ts — Source of truth delle tinte di categoria (Filosofia).
 *
 * Ogni TIPO di pezzo ha la SUA tinta, identica ovunque (mappe SVG, chip,
 * legende). Gli SVG generati in TS usano questi hex; le stesse tinte sono
 * dichiarate come `--cat-*` in `styles/tokens-brand.css` → TENERE IN SYNC.
 *
 * L'iris del brand (`philosopher`) è RISERVATO a selezione / nodo-centrale,
 * mai come categoria generica (come il bordeaux del golden per `author`).
 */

export const CATEGORY_COLORS = {
  philosopher: '#5850c8', // iris — filosofo / centrale (riservato selezione)
  concept: '#1d7d8c', // teal — concetto
  problem: '#b8842e', // ambra/ocra — problema fondamentale
  tappa: '#4f7350', // salvia — tappa / brano
  argument: '#8a5aa6', // ametista — argomento
  school: '#54678f', // ardesia — scuola / corrente
} as const;

export type CategoryKey = keyof typeof CATEGORY_COLORS;

/**
 * EPOCH_COLORS — tinta della sfera-autore per periodo storico.
 * Usato da `author-sphere.ts` (mappa periodo→tinta). In sync con
 * `--epoch-*` in tokens-brand.css.
 */
export const EPOCH_COLORS = {
  antica: '#b5762f', // terracotta calda
  medievale: '#7a5aa6', // porpora
  rinascimentale: '#c9a54a', // oro / ocra brillante (distinto dalla terracotta antica)
  moderna: '#2f6f8f', // blu-petrolio
  contemporanea: '#4f7350', // verde salvia
} as const;

export type EpochKey = keyof typeof EPOCH_COLORS;

/** Fallback neutro per entità senza epoca nota. */
export const EPOCH_FALLBACK = '#6f6a86';

export function categoryColor(key: CategoryKey): string {
  return CATEGORY_COLORS[key];
}

export function epochColor(key: string | null | undefined): string {
  if (key && key in EPOCH_COLORS) return EPOCH_COLORS[key as EpochKey];
  return EPOCH_FALLBACK;
}
